import cn from "classnames";
import { useTranslation } from "react-i18next";

import { EAiAssistantChannel } from "../../aiAgents.types";

import styles from "./ChannelTag.module.scss";

interface Props {
  channel: EAiAssistantChannel;
}

const LABEL: Record<EAiAssistantChannel, string> = {
  [EAiAssistantChannel.WhatsApp]: "WhatsApp",
  [EAiAssistantChannel.InAppSupport]: "In-App Support"
};

const ChannelTag = ({ channel }: Props) => {
  const { t } = useTranslation();
  return (
    <span
      className={cn(styles.tag, {
        [styles.tagWhatsapp]: channel === EAiAssistantChannel.WhatsApp,
        [styles.tagInApp]: channel === EAiAssistantChannel.InAppSupport
      })}
    >
      {t(LABEL[channel])}
    </span>
  );
};

export default ChannelTag;
